export const SET_GROUP = 'SET_GROUP';
export const SET_GROUPALLCALENDAR = 'SET_GROUPALLCALENDAR';
export const SET_GROUPALLCALENDAR_SUCCESS = 'SET_GROUPALLCALENDAR_SUCCESS';
export const SET_ALLGROUP = 'SET_ALLGROUP';
export const SET_PRICESINFO = 'SET_PRICESINFO';
export const SET_PRICESINFO_SUCCESS = 'SET_PRICESINFO_SUCCESS';
export const SET_TODAYMORE = 'SET_TODAYMORE';
export const SET_TODAYMORE_SUCCESS = 'SET_TODAYMORE_SUCCESS';
export const SET_GROUPALLTOURS = 'SET_GROUPALLTOURS';
export const SET_GROUPALLTOURS_SUCCESS = 'SET_GROUPALLTOURS_SUCCESS';
export const SET_GROUPDETAIL_SYNC = 'SET_GROUPDETAIL_SYNC';
export const SET_GROUPDETAIL = 'SET_GROUPDETAIL';
export const SET_GROUPDETAIL_SUCCESS = 'SET_GROUPDETAIL_SUCCESS';
export const SET_STATIONINFO = 'SET_STATIONINFO';
export const SET_STATIONINFO_SUCCESS = 'SET_STATIONINFO_SUCCESS';
export const SET_CALENDARGROUPS_MODE = 'SET_CALENDARGROUPS_MODE';
export const SET_CALENDARGROUPS_MONTH = 'SET_CALENDARGROUPS_MONTH';
export const SET_CALENDARGROUPS_GUARANTEED = 'SET_CALENDARGROUPS_GUARANTEED';
export const SET_CALENDARGROUPS_GUARANTEEDCHECKED = 'SET_CALENDARGROUPS_GUARANTEEDCHECKED';
export const SET_CALENDARGROUPS_PARMISENSUREGROUP = 'SET_CALENDARGROUPS_PARMISENSUREGROUP';
export const SET_SKI = 'SET_SKI';
export const SET_SKI_SUCCESS = 'SET_SKI_SUCCESS';
export const SET_FLIGHTINFO = 'SET_FLIGHTINFO';
export const SET_FLIGHTINFO_SUCCESS = 'SET_FLIGHTINFO_SUCCESS';
export const SET_ISANCHORSHOW = 'SET_ISANCHORSHOW';
export const SET_CHOOSEDATEM = 'SET_CHOOSEDATEM';
export const SET_ISCALENDARSHOWM = 'SET_ISCALENDARSHOWM';
export const SET_CURRENTTOURID = 'SET_CURRENTTOURID';
export const SET_CALLJSON = 'SET_CALLJSON';
export const SET_CALLJSON_SUCCESS = 'SET_CALLJSON_SUCCESS';
export const SET_SCHEDULESACTIVE = 'SET_SCHEDULESACTIVE';
export const SET_ISSEARCHPANELFIXED = 'SET_ISSEARCHPANELFIXED';

// switcherReducer
export const SET_CONTACTTELOPEN = 'SET_CONTACTTELOPEN';
export const SET_ABOARDDEPOPEN = 'SET_ABOARDDEPOPEN';
export const SET_NEXTSTEPLOADING = 'SET_NEXTSTEPLOADING';